module.exports = __webpack_public_path__ + "img/update.81505c73.png";